import React from 'react';

export const AIIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="17.778" height="16" viewBox="0 0 17.778 16">
            <path
                id="magic_button_FILL0_wght400_GRAD0_opsz48"
                d="M86.756,226.289l1.113-2.42,2.42-1.113-2.42-1.113-1.113-2.42-1.113,2.42-2.42,1.113,2.42,1.113Zm0,3.222-2.111-4.644L80,222.756l4.644-2.111L86.756,216l2.111,4.644,4.644,2.111-4.644,2.111ZM94.4,232l-1.044-2.333-2.333-1.044,2.333-1.067,1.044-2.311,1.067,2.311,2.311,1.067-2.311,1.044ZM86.756,222.756Z"
                transform="translate(-80 -216)"
                fill="#fff"
            />
        </svg>
    );
